<template>
  <p class="ContentTip">
    <slot />
  </p>
</template>

<script>
export default {
  name: 'ContentTip'
}
</script>

<style lang="scss">
  .ContentTip {
    padding: 16px !important;
    // background: $gray_light !important;
    background: $antraciet_blauw_lightest;
    line-height: 24px !important;

    h1, h2, h3, h4, h5, h6, strong {
      color: $antraciet_blauw;
    }
  }
</style>
